/**
 * Drops the adjacent seats from a seat selection.
 * An adjacent seat is bought to travel with an empty seat next to you, so it is
 * not an extra passenger: anything counted per traveller has to leave them out.
 * It is a ticket of its own, though, so per-ticket charges must *not* use this
 * filter — the platform-usage fee of MID-747 is one of them, and `getFixedFeeTotals`
 * in `hooks/usePricingBeforeCheckout` counts every selected seat on purpose.
 * The predicate lives in its own leaf module so pricing code can reuse it without
 * pulling in the whole `utils/passengers` chain, which reaches the Redux store.
 * @param {Array} [seats] - Selected seats.
 * @returns {Array} The seats that count as a passenger.
 */
const removeAdjacentSeats = (seats = []) => seats.filter((seat) => !seat.isPickedAsAdjacent);

export default removeAdjacentSeats;
